import script from "./notifications-page.vue?vue&type=script&setup=true&lang=js"
export * from "./notifications-page.vue?vue&type=script&setup=true&lang=js"

import "./notifications-page.vue?vue&type=style&index=0&id=8a8b5ea0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a8b5ea0"]])

export default __exports__